export interface Option {
  value: string;
  label?: React.ReactNode;
  disabled?: boolean;
  children?: Option[];
  isLeaf?: boolean;
}

const sortOption = (option: Option) => {
  if (!option.children || option.children.length === 0) {
    return;
  }
  option.children.sort((a: Option, b: Option) => {
    return a.value.localeCompare(b.value, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });

  option.children.forEach((childOption) => {
    sortOption(childOption);
  });
};

function updateParentDisabled(option: Option) {
  if (!option.children || option.children.length === 0) {
    return;
  }

  const allChildrenDisabled = option.children.every((child) => {
    updateParentDisabled(child);
    return child.disabled === true;
  });

  option.disabled = allChildrenDisabled;
}

export const generateHouseHoldNumberCascader = (
  data: string[],
  noMembersHouseholdNumbers: string[]
): Option[] => {
  const result: Option[] = [];
  const spreadData = data
    .sort((a, b) => a.localeCompare(b))
    .map((item) => item.split('-'));

  spreadData.forEach((numbers) => {
    let currentOptions = result;
    numbers.forEach((number, index, arr) => {
      let target = currentOptions.find((option) => option.value === number);
      if (!target) {
        const newOption: Option = {
          value: number,
          label: number,
          disabled: false,
        };
        currentOptions.push(newOption);
        target = newOption;
      }
      if (index !== arr.length - 1) {
        target.children = target.children || [];
        currentOptions = target.children;
      } else {
        target.disabled = noMembersHouseholdNumbers.includes(numbers.join('-'));
      }
    });
  });

  const updatedDisabledResult = result.map((option) => {
    updateParentDisabled(option);
    return option;
  });

  updatedDisabledResult.forEach((option) => {
    sortOption(option);
  });

  return updatedDisabledResult;
};
